import { AnyAsyncThunk } from '@reduxjs/toolkit/dist/matchers';
import React,{useState} from 'react';
import { Form,Table,Image, } from "react-bootstrap";
import { isAdmin } from "../../../../features/localStorage";
import Save from '../../../../assets/images/save-line.svg';

const EthicsTableList = ({tData, isAddSelected = false, isDeleteSelected = true}: {tData:any,isAddSelected?:Boolean, isDeleteSelected?:Boolean}) => {
  
  const   [MasterChecked,setMasterChecked] =   useState(false);
  const   [SelectedList,setSelectedList] = useState([]);
  const [List , setList] = useState(tData)
  const [tempList , setTempList] = useState(tData)


  const onMasterCheck = (e:React.ChangeEvent<HTMLInputElement>) => {
    let newList = tempList.map((obj:any) => Object.assign({}, obj, {selected:e.target.checked}));
    
    setMasterChecked(e.target.checked)
    setList(newList);
    setTempList(newList);
    setSelectedList(List.filter((e:any) => e.selected))
  
  }

  const newMappedList = (data:any, item:any, checked:boolean) => {
    let newData = data.map((obj:any) => {
        let selected = obj.selected
        if (obj.id === item.id) {
            selected = checked;
        }
        return {
            ...obj,
            selected: selected       
        }
    });
    return newData
   }

  const onItemCheck = (e:React.ChangeEvent<HTMLInputElement>, item:any) => {

    
    let newList = newMappedList(tempList, item,  e.target.checked)
    
    const totalItems = newList.length;
    const totalCheckedItems = newList.filter((e:any) => e.selected).length;

    setMasterChecked(totalItems === totalCheckedItems)
    setList(newList);
    setTempList(newList);
    setSelectedList(List.filter((e:any) => e.selected))
  }

  const getSelectedRows = () => {
    setSelectedList(List.filter((e:any) => e.selected))
  }

    return (
        <>
            <Table style={styles.border} responsive>
              <thead>
                <tr>                  
                    <th className="py-3 ps-3" style={styles.tableHeading}>Sr. No.</th>
                    <th className="py-3 ps-3" style={styles.tableHeading}>EMP No.</th>
                    <th className="py-3 ps-3" style={styles.tableHeading}>Name</th>
                    <th className="py-3 ps-3" style={styles.tableHeading}>Designation</th>
                    <th className="py-3 ps-3" style={styles.tableHeading}>Location</th>
                    <th className="py-3 ps-3" style={styles.tableHeading}>Sector</th>
                    <th className="py-3 ps-3" style={styles.tableHeading}>Unit</th>
                    <th className="py-3 ps-3" style={styles.tableHeading}>Email ID</th>
                </tr>
                </thead>
                <tbody>
                                
                {
                    tData?.map((val: any) => {
                        return(                            
                                <tr style={styles.border} key={val.id}>                                   
                                    <td className="py-3 ps-3" style={styles.tableContents}>{val.id}</td>
                                    <td className="py-3 ps-3" style={styles.tableContents}>{val.employeeId}</td>
                                    <td className="py-3 ps-3" style={styles.tableContents}>{val.name}</td>
                                    <td className="py-3 ps-3" style={styles.tableContents}>{val.designation}</td>
                                    <td className="py-3 ps-3" style={styles.tableContents}>{val.location}</td>
                                    <td className="py-3 ps-3" style={styles.tableContents}>{val.sector}</td>
                                    <td className="py-3 ps-3" style={styles.tableContents}>{val.unit}</td>
                                    <td className="py-3 ps-3" style={styles.tableContents}>{val.emailId}<br /></td>
                                </tr>
                        );
                    })
                }
            </tbody>           
            </Table>
        </>
    );
}

const styles: any = {
  textfield:{
    width:"60%",
},  

save:{color:"#e31837",fontSize:"12px",},
    divWhite: {
      backgroundColor: "#fffff",
      padding: "24px",
    },
    tableHeading: {
      fontFamily: "Saira",
      fontSize: "12px",
      fontWeight: "600",
    },
    tableContents: {
      fontFamily: "Saira",
      fontSize: "12px",
      fontWeight: "normal",
    },
    border: {
      border: "solid 1px #e4e4e4",
    },
  };

export default EthicsTableList;
